<template>
  <TableComp
    :headers="headers"
    :name="$t('global.ssh-keys')"
    :status="status"
    :pagination="pagination"
    :number-of-items="keys.length"
    @update:list="updateList"
    :emptyBoldMessage="$t('global.no-ssh-keys-bold-message')"
    emptyImage="ssh-keys"
    :emptyMessage="$t('global.no-ssh-keys-message')"
  >
    <template #desktop>
      <TableRow v-for="key in keys" v-bind:key="key.id" :rows="rows(key)">
        <template #actionItems>
          <ActionIcons :actions="actionItems(key)" />
        </template>
      </TableRow>
    </template>
    <template #mobile>
      <TableMobileRow
        v-for="key in keys"
        v-bind:key="key.id"
        :header-title="key.name"
        :action-items="actionItems(key)"
      />
    </template>
  </TableComp>
</template>

<script>
import ActionIcons from "@/components/display/ActionIcons";
import ConfirmationModal from "@/components/display/ConfirmationModal";
import { dateFormat } from "leatherman-js/utils/formatters/time";
import NavLink from "@/classes/NavLink";
import store from "@/store";
import TableComp from "@/components/display/table/TableComp";
import TableHeader from "@/classes/TableHeader";
import TableMobileRow from "@/components/display/table/TableMobileRow";
import TableRow from "@/components/display/table/TableRow";
import { timeSince } from "leatherman-js/utils/formatters/time";

export default {
  name: "sshKeysTable",
  props: {
    keys: Array,
    pagination: Object,
    status: Object,
  },
  components: {
    ActionIcons,
    TableComp,
    TableMobileRow,
    TableRow,
  },
  setup(props, { root }) {
    const headers = [
      new TableHeader(root.$t("global.name"), null, null),
      new TableHeader(root.$t("global.fingerprint"), "justify-content-center", null),
      new TableHeader(root.$t("global.size"), "justify-content-center", null),
      new TableHeader(root.$t("global.creation-date"), "justify-content-center", null),
      new TableHeader(),
    ];

    const updateList = (event) => {
      const { pagination } = event;
      store.dispatch("sshKeys/getList", {
        pageIndex: pagination?.index,
        pageSize: pagination?.size,
      });
    };

    const confirmDeleteKey = (key) => {
      return store.dispatch("sshKeys/deleteKey", key.id);
    };

    const deleteKey = (key) => {
      store.dispatch("modals/open", {
        template: ConfirmationModal,
        data: {
          confirm: confirmDeleteKey.bind(null, key),
          errorMessage: root.$t("global.error-deleting-ssh-key", { name: key.name }),
          message:
            root.$t("global.confirm-ssh-key-delete", { name: key.name }) +
            "\n\n" +
            root.$t("global.fingerprint-item", { fingerprint: key.fingerPrint }),
          title: root.$t("global.delete-ssh-key"),
          variant: "danger",
        },
      });
    };

    const actionItems = (key) => [
      new NavLink(
        root.$t("global.delete-ssh-key"),
        "trash",
        () => deleteKey(key),
        false,
        null,
        "epsilon"
      ),
    ];
    const rows = (key) => [
      { value: key.name },
      { value: key.fingerPrint, style: "text-center" },
      { value: key.keySize, style: "text-center" },
      { value: dateFormat(key.creationDate), style: "text-center" },
    ];

    return {
      dateFormat,
      headers,
      actionItems,
      rows,
      timeSince,
      updateList,
    };
  },
};
</script>
